export default __webpack_public_path__ + "static/media/homeiconactive.d9e35401.svg";